// Feature 015: a comment or post deleted in Telegram stays in place, struck through, with a
// "deleted in Telegram · <time>" label. The cabinet sends `remoteDeletedAt` (ISO 8601) or null.
import {format} from "date-fns";
import {convertToMomentLocale} from "./functions";

type Translate = (key: string) => string;

export const REMOTE_DELETED_DATE_FORMAT = "E, dd MMM yyyy, HH:mm";

// "" when the item is not deleted; the label without a time when the date cannot be parsed.
export function formatRemoteDeletedLabel(remoteDeletedAt: string | null | undefined, t: Translate, language: string): string {
    if (!remoteDeletedAt) return "";
    const label = t("common:deletedInTelegram");
    const date = new Date(remoteDeletedAt);
    if (isNaN(date.getTime())) return label;
    return label + " · " + format(date, REMOTE_DELETED_DATE_FORMAT, {locale: convertToMomentLocale(language)});
}
